import React from "react";
import {
  Create,
  Datagrid,
  Edit,
  FormTab,
  PasswordInput,
  ReferenceArrayInput,
  SelectArrayInput,
  TabbedForm,
  TextField,
  TextInput,
} from "react-admin";
import { List } from "../components";
import { PERMISSIONS } from "../constants";

const required = (message = "Obrigatório") => (value) =>
  value ? undefined : message;

const ExternalPartnerList = (props) => (
  <List {...props} title="Parceiros Externos" exporter={false}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="name" label="Nome" />
      <TextField source="login" label="Login" />
    </Datagrid>
  </List>
);

// Transforma externalPartnerChains (vindo do backend) em chainIds (para o SelectArrayInput)
const parseExternalPartner = (record) => ({
  ...record,
  chainIds: (record?.externalPartnerChains || []).map((c) => c.chainId),
});

const ExternalPartnerEdit = (props) => (
  <Edit
    title="Editar parceiro externo"
    mutationMode="pessimistic"
    queryOptions={{ select: parseExternalPartner }}
    transform={(data) => {
      const { externalPartnerChains, ...rest } = data;
      // Quando a senha vem vazia, não enviar (mantém a atual)
      if (!rest.password) { delete rest.password; }
      return rest;
    }}
    {...props}
  >
    <TabbedForm>
      <FormTab label="Identificação">
        <TextInput source="name" label="Nome" validate={required()} />
        <TextInput source="login" label="Login" validate={required()} />
        <PasswordInput
          source="password"
          label="Nova senha (deixe em branco para manter)"
        />
      </FormTab>
      <FormTab label="Redes vinculadas">
        <ReferenceArrayInput
          source="chainIds"
          reference="chains"
          perPage={false}
          sort={{ field: "name", order: "ASC" }}
        >
          <SelectArrayInput
            label="Redes"
            optionText="name"
            emptyText="Nenhuma"
            fullWidth
          />
        </ReferenceArrayInput>
      </FormTab>
    </TabbedForm>
  </Edit>
);

const ExternalPartnerCreate = (props) => (
  <Create title="Novo parceiro externo" {...props}>
    <TabbedForm>
      <FormTab label="Identificação">
        <TextInput source="name" label="Nome" validate={required()} />
        <TextInput source="login" label="Login" validate={required()} />
        <PasswordInput
          source="password"
          label="Senha"
          validate={required()}
        />
      </FormTab>
      <FormTab label="Redes vinculadas">
        <ReferenceArrayInput
          source="chainIds"
          reference="chains"
          perPage={false}
          sort={{ field: "name", order: "ASC" }}
        >
          <SelectArrayInput
            label="Redes"
            optionText="name"
            emptyText="Nenhuma"
            fullWidth
          />
        </ReferenceArrayInput>
      </FormTab>
    </TabbedForm>
  </Create>
);

const resource = {
  list: ExternalPartnerList,
  edit: ExternalPartnerEdit,
  create: ExternalPartnerCreate,
  name: "external-partners",
  permissions: [PERMISSIONS.ADMIN],
};

export default resource;
